<template>
  <div class="col-9 p-4 h-100 overflow-auto">
    <div class="w-75 m-auto d-flex flex-column">
      <div class="m-auto d-inline-block position-relative">
        <a href="#" class="image-panel image-panel-5 rounded rounded-circle">
          <img :src="user.avatar" alt="">
        </a>
        <a href="#" class="position-absolute bg-black500 rounded rounded-circle" style="bottom: 0.5em; right: 0.5em;" @click="upload">
          <span class="m-1 material-icons md-18 text-white">photo_camera</span>
          <input ref="fileInput" type="file" hidden accept="image/*" @change="uploadImage">
        </a>
      </div>
      <div class="my-3">
        <h6 class="font-size-md">
          <span class="ml-n1 text-danger">*</span>
          <span class="flex-grow-1">{{ $t('frame.accountSetting.form.name.label') }}</span>
        </h6>
        <b-form-input
          v-model="user.name"
          :state="nameValid ? null : false"
          :placeholder="$t('frame.accountSetting.form.name.placeholder')"
          size="sm"
          class="rounded-pill"
        />
        <b-form-invalid-feedback v-if="!nameValid" id="input-live-feedback">
          {{ error.name }}
        </b-form-invalid-feedback>
      </div>
      <div class="my-3">
        <h6 class="font-size-md">
          <span class="ml-n1 text-danger">*</span>
          <span class="flex-grow-1">E-mail</span>
        </h6>
        <b-form-input v-model="user.email" size="sm" class="rounded-pill" readonly />
      </div>
      <div class="my-3">
        <h6 class="font-size-md">
          <span class="flex-grow-1">{{ $t('frame.accountSetting.form.mobile.label') }}</span>
        </h6>
        <b-form-input
          v-model="user.mobile"
          :state="mobileValid ? null : false"
          :placeholder="$t('frame.accountSetting.form.mobile.placeholder')"
          size="sm"
          class="rounded-pill"
        />
        <b-form-invalid-feedback v-if="!mobileValid" id="input-live-feedback">
          {{ error.mobile }}
        </b-form-invalid-feedback>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object
    },
    error: {
      type: Object
    }
  },
  data() {
    return {
      user: this.value
    };
  },
  computed: {
    nameValid() {
      return (this.error.name || '') === '';
    },
    mobileValid() {
      return (this.error.mobile || '') === '';
    }
  },
  watch: {
    value: {
      handler(val) {
        this.user = val;
      },
      deep: true
    },
    user: {
      handler(val) {
        this.$emit('input', val);
      },
      deep: true
    }
  },
  created() {
  },
  methods: {
    // 選擇圖片按鈕點擊
    upload() {
      this.$refs.fileInput.click();
    },
    // 選擇圖片
    async uploadImage(e) {
      const image = await this.compressImage(e.target.files[0]);
      this.$set(this.user, 'avatar', image);
      this.avatarChanged = true;
    },
    // 壓縮圖片
    compressImage(file) {
      const vm = this;
      const reader = new FileReader();
      const windowURL = window.URL || window.webkitURL;

      return new Promise((resolve, reject) => {
        reader.readAsArrayBuffer(file);

        reader.onload = (e) => {
          try {
            const blob = new Blob([e.target.result]);
            const blobUrl = windowURL.createObjectURL(blob);

            const image = new Image();
            image.src = blobUrl;

            image.onload = () => {
              try {
                const resized = vm.resizeImage(image);
                resolve(resized);
              } catch (ex) {
                reject(ex);
              }
            };
          } catch (ex) {
            reject(ex);
          }
        };
      });
    },
    // 調整大小
    resizeImage(image) {
      const canvas = document.createElement('canvas');
      const { width } = image;
      const { height } = image;
      const max = 150;

      if (width > height) {
        if (width > max) {
          canvas.height = Math.round(height * (max / width));
          canvas.width = max;
        }
      } else if (height > max) {
        canvas.width = Math.round(width * (max / height));
        canvas.height = max;
      }

      const ctx = canvas.getContext('2d');
      ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

      return canvas.toDataURL('image/jpeg', 0.7);
    }
  }
};
</script>
